















import Vue from 'vue'
import seatings, { SeatingType } from '@/services/Seatings'
import moment from 'moment'
// @ts-ignore
import Datepicker from 'vuejs-datepicker'
// @ts-ignore
import * as locales from 'vuejs-datepicker/dist/locale'

export default Vue.extend({
  name: 'OwnerNewAccessCode',
  components: {
    Datepicker,
  },
  data() {
    return {
      format: 'MMMM Do YYYY, h:mm:ss a',
      restaurantId: this.$router.currentRoute.params.restaurantId,
      invalidTo: moment().add(-1, 'd'),
      newMoment: moment().startOf('d'),
      seatings: [] as SeatingType[],
    }
  },
  async mounted() {
    await seatings.getAllSeatings(this.$router.currentRoute.params.restaurantId, s => {
      this.seatings = s
      this.getFirstFreeDay()
    })
  },
  methods: {
    async addSeating() {
      await seatings.create(this.restaurantId, this.newDate)
    },
    getFirstFreeDay() {
      let todayKey = moment(this.newDate).format('YYYYMMDD')
      const filledDays = this.seatings.map((s: SeatingType) =>
        moment(new Date(s.validFrom)).format('YYYYMMDD')
      )

      let i = 0
      while (filledDays.indexOf(todayKey) !== -1 && i < 100) {
        this.newMoment = moment(this.newDate).add(1, 'd')
        todayKey = moment(this.newDate).format('YYYYMMDD')
        i++
      }
    },
    handleInput(val: Date | null) {
      if (val) {
        this.newMoment = moment(val)
      }
    },
  },
  computed: {
    disabledDates() {
      return {
        to: this.invalidTo.toDate(),
        dates: this.filledDates,
      }
    },
    filledDates() {
      return this.seatings.map((s: SeatingType) => new Date(s.validFrom))
    },
    newDate() {
      return this.newMoment.toDate()
    },
    datepickerLang() {
      return locales[this.$route.params.lang]
    },
  },
})
